/* @flow */
import invariant from 'invariant';
import * as React from 'react';
import { Container } from 'flux/utils';

import AuthActions from 'auth/AuthActions';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import ChatActions from 'chat/actions/ChatActions';
import ChatStore from 'chat/stores/ChatStore';
import CurrentUser from 'auth/CurrentUser';
import LoadingIndicator from 'components/LoadingIndicator';
import ErrorActions from 'actions/ErrorActions';
import UserActions from 'user/UserActions';
import View from 'components/View';

import type { RouterState } from 'lib/ReactRouterTypes';

export class LeaveChatView extends React.Component<{}, *> {
  state = {};

  static getStores() {
    return [ChatStore];
  }

  static onEnter(nextState: RouterState, replaceWith: Function, callback: Function) {
    AuthActions.jwtTokenSignIn(nextState.params.token);
    // XXX this promise chain is convoluted but I'm just removing linkStateWithStores right now
    UserActions.loadCurrentUser(nextState.params.token)
      .then(
        () => {
          const payload = CurrentUser.getTokenPayload();
          invariant(
            payload && payload.chat_uuid,
            'LeaveChatView onEnter payload missing chat_uuid'
          );
          return ChatActions.loadChat(payload.chat_uuid);
        },
        () => {
          ErrorActions.expiredToken('LEAVE_CHAT');
          replaceWith('/error');
          callback();
        }
      )
      .then(
        () => {
          callback();
        },
        () => {
          replaceWith('/error');
          callback();
        }
      );
  }

  static calculateState() {
    const payload = CurrentUser.getTokenPayload();
    const chat = payload && ChatStore.getChat(payload.chat_uuid);

    return { chat };
  }

  handleLeaveButtonClick = () => {
    invariant(this.state.chat, 'missing chat in state');
    ChatActions.leaveChat(this.state.chat);
  };

  renderConfirmation() {
    const title = 'Leave this conversation?';
    const subtext = 'You won’t receive new messages in this conversation.';
    return (
      <View center className="LeaveChatView">
        <Box size="xsmall" title={title} subtext={subtext} glyph="caution" glyphColor="apple">
          <BoxBody>
            <Button onClick={this.handleLeaveButtonClick} level="primary">
              Yes, leave this conversation
            </Button>
          </BoxBody>
        </Box>
      </View>
    );
  }

  renderLeftMessage() {
    const title =
      'You left this conversation. If you’d like to re-join, please ask your teacher to add you ' +
      'back.';
    const subtext = 'You can now close this browser.';
    return (
      <View center className="LeaveChatView">
        <Box size="small" title={title} subtext={subtext} />
      </View>
    );
  }

  render() {
    if (!this.state.chat) {
      return (
        <View center className="LeaveChatView">
          <LoadingIndicator />
        </View>
      );
    } else if (this.state.chat.canLeave()) {
      return this.renderConfirmation();
    } else {
      return this.renderLeftMessage();
    }
  }
}

export default Container.create(LeaveChatView);
